import React, { useState } from 'react'
import useToggleDropdown from './hooks/useToggleDropdown';
import { useSelector } from 'react-redux';
import { sortClass } from './utils/filter';

const PackageSort = ({ handleSort }) => {
    const lang = useSelector((state) => state.culture.language);
    const [sortType, setSortType] = useState('priceLowToHigh')


    const { isDropdownOpen, setIsDropDownOpen, toggleDropdown, dropdownRef } = useToggleDropdown()

    const handleSortOptionClick = (type) => {
        setSortType(type)
        handleSort(type)
    }


    return (
        <div className="htlSortmain">
            <div className="Filterbtn">
                <i className="mobfilterIcon" /> {lang.filter}
            </div>
            <div className="mobSortbtn">
                <i className="mobSortIcon" /> {lang.sort}
            </div>
            <div className="htlSortBtn FSort_dropdown" onClick={toggleDropdown} > {lang.sort_by}: {lang[sortClass(sortType)["type"]]}</div>
            <div
                className="FSort_dropdown_menu FSort"

                style={{ display: isDropdownOpen ? "block" : "none" }}
                ref={dropdownRef}
            >
                <ul>
                    <li className="d-flex align-items-center justify-content-between">
                        <div>
                            <span>{lang.price}</span>
                        </div>
                        <div>
                            <button className={`SortUpBtn ${sortType === "priceLowToHigh" && 'active'} `} type="button" onClick={() =>
                                handleSortOptionClick(
                                    "priceLowToHigh"
                                )
                            }>
                                {" "}
                                <i className="SortUp" />{" "}
                            </button>
                            <button className={`SortDownBtn ${sortType === "priceHighToLow" && 'active'}`} type="button" onClick={() =>
                                handleSortOptionClick(
                                    "priceHighToLow"
                                )
                            }>
                                {" "}
                                <i className="SortDown" />{" "}
                            </button>
                        </div>
                    </li>
                    <li className="d-flex align-items-center justify-content-between">
                        <div>
                            <span>{lang.name}</span>
                        </div>
                        <div>
                            <button className={`SortUpBtn ${sortType === "nameLowToHigh" && 'active'} `} type="button" onClick={() =>
                                handleSortOptionClick(
                                    "nameLowToHigh"
                                )
                            }>
                                {" "}
                                <i className="SortUp" />{" "}
                            </button>
                            <button className={`SortDownBtn ${sortType === "nameHighToLow" && 'active'}`} type="button" onClick={() =>
                                handleSortOptionClick(
                                    "nameHighToLow"
                                )
                            }>
                                {" "}
                                <i className="SortDown" />{" "}
                            </button>
                        </div>
                    </li>
                    <li className="d-flex align-items-center justify-content-between">
                        <div>
                            <span>{lang.duration}</span>
                        </div>
                        <div>
                            <button className={`SortUpBtn ${sortType === "durationLowToHigh" && 'active'} `} type="button" onClick={() =>
                                handleSortOptionClick(
                                    "durationLowToHigh"
                                )
                            }>
                                {" "}
                                <i className="SortUp" />{" "}
                            </button>
                            <button className={`SortDownBtn ${sortType === "durationHighToLow" && 'active'}`} type="button" onClick={() =>
                                handleSortOptionClick(
                                    "durationHighToLow"
                                )
                            }>
                                {" "}
                                <i className="SortDown" />{" "}
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
        </div >
    )
}

export default PackageSort